import firebase from "firebase";
// new
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyB2wZsMyaZ_C1zuy8xw5XxWraastFY-8NA",
//   authDomain: "treasuregrowthinvestment-69794.firebaseapp.com",
//   projectId: "treasuregrowthinvestment-69794",
//   storageBucket: "treasuregrowthinvestment-69794.appspot.com",
//   messagingSenderId: "608157604123",
//   appId: "1:608157604123:web:bee33b327d65e0a9b41bbe",
//   measurementId: "G-T2CD0VCNNT"
// };
// For Firebase JS SDK v7.20.0 and later, measurementId is optional


// old
const firebaseConfig = {
  apiKey: "AIzaSyD5SOz7GkKrWyGum6DiWECgMke1n6xXx-U",
  authDomain: "treasuregrowthinvestment.firebaseapp.com",
  projectId: "treasuregrowthinvestment",
  storageBucket: "treasuregrowthinvestment.appspot.com",
  messagingSenderId: "1007513231390",
  appId: "1:1007513231390:web:472370996c200f69438e0f",
  measurementId: "G-0YDS8VGGV3"
};
firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export default firebase;
